import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ERcbTier } from "@devowl-wp/api-real-cookie-banner";
import { App, Badge, Card, Collapse, Divider, Tag, Tooltip } from "antd";
import { UPSELL_TAG_BACKGROUND_COLOR, useI18n, useUpsell, useUpsellModal } from "../..";
const { Meta } = Card;
function TemplateCenterCard(param) {
    let { template, renderActions, renderTags, onSelect, grayOutAlreadyExisting, onAcknowledgementClick } = param;
    const { __, _i } = useI18n();
    const { modal } = App.useApp();
    const { isPro, isDemoEnv } = useUpsell();
    const { headline, subHeadline, logoUrl, tier, consumerData: { tags, isDisabled, isCreated, isIgnored, acknowledgement } } = template;
    const { technicalHandlingIntegration } = template.consumerData;
    const disabledTranslatedText = __("Disabled");
    const showProBadge = tier === ERcbTier.Pro && (!isPro || isDemoEnv);
    const { open: openProModal, modal: proModal } = useUpsellModal({
        title: __("Want to use %s template?", headline),
        feature: "preset",
        description: `${__("Only a limited number of templates for services and content blockers are available in the %s version of Real Cookie Banner. Get the PRO version now and create a service or content blocker from this template with just one click!", (isDemoEnv ? __("Demo") : __("Free")).toLowerCase())}${isDemoEnv ? "" : `

${__("You can create this service yourself in the free version without any restrictions and research the necessary information.")}`}`
    }, // PRO Presets are deactivate on try.devowl.io
    isDemoEnv ? false : undefined);
    const handleClick = (e)=>{
        // This event is bubbled also for the external URLs table in the modal dialog
        // Check if the click comes directly from the card
        if (!e.target.closest(".rcb-antd-card,.rcb-template-card-create-link")) {
            return;
        }
        if (acknowledgement) {
            const { paragraphs, accordion, buttonAction, buttonLabel } = acknowledgement;
            const createdModal = modal.info({
                icon: null,
                width: 800,
                closable: true,
                okButtonProps: {
                    style: {
                        display: "none"
                    }
                },
                content: /*#__PURE__*/ _jsxs("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: template.logoUrl,
                            style: {
                                display: "block",
                                paddingTop: 15,
                                margin: "auto",
                                height: 176
                            }
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            style: {
                                margin: "10px 0 0"
                            },
                            children: template.headline
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            style: {
                                marginTop: 0
                            },
                            children: template.subHeadline
                        }),
                        /*#__PURE__*/ _jsx(Divider, {
                            children: __("Special circumstances for this service")
                        }),
                        paragraphs.map((paragraph)=>/*#__PURE__*/ _jsx("p", {
                                style: {
                                    textAlign: "left"
                                },
                                children: _i(paragraph, {
                                    strong: /*#__PURE__*/ _jsx("strong", {}),
                                    u: /*#__PURE__*/ _jsx("u", {
                                        style: {
                                            textDecorationStyle: "dashed"
                                        }
                                    })
                                })
                            }, paragraph)),
                        accordion && /*#__PURE__*/ _jsx(Collapse, {
                            style: {
                                textAlign: "left"
                            },
                            defaultActiveKey: Object.keys(accordion)[0],
                            items: Object.keys(accordion).map((key)=>({
                                    key,
                                    label: key,
                                    children: /*#__PURE__*/ _jsx("p", {
                                        style: {
                                            margin: 0
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: accordion[key]
                                        }
                                    })
                                }))
                        }),
                        onAcknowledgementClick && /*#__PURE__*/ _jsx("div", {
                            style: {
                                marginTop: 10
                            },
                            children: /*#__PURE__*/ _jsx("button", {
                                className: "button button-large button-primary",
                                onClick: ()=>{
                                    createdModal.destroy();
                                    onAcknowledgementClick == null ? void 0 : onAcknowledgementClick(buttonAction, template);
                                },
                                children: buttonLabel
                            })
                        })
                    ]
                })
            });
        } else if (showProBadge) {
            openProModal();
        } else if (!isDisabled) {
            onSelect == null ? void 0 : onSelect(template);
        }
    };
    const coverImage = /*#__PURE__*/ _jsx("img", {
        style: {
            width: "90%"
        },
        src: logoUrl
    });
    const useTags = renderTags ? renderTags({
        ...tags
    }, template) : tags;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            proModal,
            /*#__PURE__*/ _jsx(Tooltip, {
                title: isDisabled ? /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: tags[disabledTranslatedText]
                    }
                }) : undefined,
                children: /*#__PURE__*/ _jsx(Card, {
                    className: "rcb-antd-template-card",
                    hoverable: !isDisabled,
                    style: {
                        opacity: isDisabled || grayOutAlreadyExisting && (isCreated || isIgnored) ? 0.6 : 1
                    },
                    onClick: handleClick,
                    cover: technicalHandlingIntegration ? /*#__PURE__*/ _jsx(Badge.Ribbon, {
                        text: /*#__PURE__*/ _jsx(Tooltip, {
                            title: _i(__("The {{strong}}%s{{/strong}} plugin is recommending this service.", technicalHandlingIntegration.name), {
                                strong: /*#__PURE__*/ _jsx("strong", {})
                            }),
                            children: /*#__PURE__*/ _jsx("div", {
                                children: __("Integration")
                            })
                        }),
                        children: coverImage
                    }) : coverImage,
                    actions: renderActions ? renderActions(template, handleClick) : [],
                    children: /*#__PURE__*/ _jsx(Meta, {
                        title: /*#__PURE__*/ _jsxs("span", {
                            children: [
                                showProBadge && /*#__PURE__*/ _jsx(Tag, {
                                    color: UPSELL_TAG_BACKGROUND_COLOR,
                                    children: "PRO"
                                }),
                                !!tags && Object.keys(useTags).map((key)=>/*#__PURE__*/ _jsx(Tooltip, {
                                        title: key === disabledTranslatedText || !tags[key] ? undefined : /*#__PURE__*/ _jsx("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: tags[key]
                                            }
                                        }),
                                        children: /*#__PURE__*/ _jsx(Tag, {
                                            children: key
                                        })
                                    }, key)),
                                /*#__PURE__*/ _jsx("br", {}),
                                headline
                            ]
                        }),
                        description: subHeadline ? subHeadline : /*#__PURE__*/ _jsx("i", {
                            children: __("No description")
                        })
                    })
                })
            })
        ]
    });
}
export { TemplateCenterCard };
